import { render, staticRenderFns } from "./export-box.vue?vue&type=template&id=434c4087&scoped=true"
import script from "./export-box.vue?vue&type=script&lang=js"
export * from "./export-box.vue?vue&type=script&lang=js"
import style0 from "./export-box.vue?vue&type=style&index=0&id=434c4087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434c4087",
  null
  
)

export default component.exports